import React from "react";

const ThreeDotsIcon = ({ fill = "#333", ...props }) => (
  <svg width="32" height="10" viewBox="0 0 32 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="5" cy="5" r="3" fill={fill} />
    <circle cx="16" cy="5" r="3" fill={fill} />
    <circle cx="27" cy="5" r="3" fill={fill} />
  </svg>
);

export default ThreeDotsIcon;
